import { cx } from '@vizit/theme';
import * as React from 'react';
import { Dialog as AriaDialog, type DialogProps as AriaDialogProps } from 'react-aria-components';

interface PopoverDialogProps extends AriaDialogProps {}

function PopoverDialog(props: PopoverDialogProps, ref: React.ForwardedRef<HTMLElement>) {
  const { className, ...other } = props;

  return <AriaDialog ref={ref} className={cx('outline outline-0', className)} {...other} />;
}

const _PopoverDialog = React.forwardRef<HTMLElement, PopoverDialogProps>(PopoverDialog);

export type { PopoverDialogProps };
export { _PopoverDialog as PopoverDialog };
